$( window ).ready(function() {
	$('.owl-carousel').owlCarousel({
      loop:true,
      margin:10,
      padding:10,
      autoplay:true,
      nav:true,
      dots:false,
      rewindNav:true,
      responsive:{
          0:{
              items:2,
            nav:false,
            dots:true
          },
          600:{
              items:4,
            nav:false,
            dots:true
          },
          1000:{
              items:6
          }
      }
        })
    });
  
$( window ).ready(function() {
        
  $(".regular").slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    responsive: [
      
      {
        
      breakpoint: 767,
      settings: {
        dots: true
      }
        
      }
    ]

  });   

});

         